module.exports = __webpack_public_path__ + "img/logo.cd8897fd.png";